/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useDocumentStore = defineStore("document", {
  actions: {
    async uploadFetch(payload) {
      let body;
      if (payload instanceof FormData) {
        body = payload;
      } else if (payload && payload.formdata instanceof FormData) {
        body = payload.formdata;
      } else if (payload && payload.formdata) {
        body = payload.formdata;
      } else {
        const formData = new FormData();
        formData.append("forGroupUid", payload?.forGroupUid ?? "");
        formData.append("forShopUid", payload?.forShopUid ?? "");
        formData.append("publicAccess", false);

        if (payload?.files) {
          if (
            Array.isArray(payload.files) ||
            (typeof FileList !== "undefined" &&
              payload.files instanceof FileList)
          ) {
            for (let i = 0; i < payload.files.length; i++) {
              formData.append("files", payload.files[i]);
            }
          } else {
            formData.append("files", payload.files);
          }
        } else if (payload?.file) {
          formData.append("files", payload.file);
        }

        body = formData;
      }

      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/upload";
          const response = http.post(pathUrl, body, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async getinfoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/info";
          const response = http.post(pathUrl, payload); // สั่งแบบ json ปกติ ไม่ต้องระบุ blob
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async getFileFetch(payload) {
      try {
        const pathUrl = "/doc-svc/document/file";

        // 1. ยิงคำสั่ง HTTP โดยระบุทั้ง responseType และ headers ให้ครบถ้วน
        const response = await http.post(pathUrl, payload, {
          responseType: 'blob',
          headers: {
            'Accept': 'application/octet-stream, image/*'
          }
        });

        // 2. ถ้าสำเร็จ ส่งข้อมูล response กลับไปตรงๆ
        return response;

      } catch (err) {
        // 3. ถ้าเจอไฟล์ 404 หรือระบบพัง ให้สวมค่ากลับเป็นออบเจกต์จำลอง
        console.warn(`ไฟล์รหัส ${payload.uid} พังบนเซิร์ฟเวอร์ (404/Error):`, err.message);

        return {
          status: err.response?.status || 404,
          data: null
        };
      }
    },

    async addFetch(payload) {
      const body = {
        name: payload.name,
        mimeType: payload.mimeType,
        data: payload.data,
        forGroupUid: "", // required for platform user, assign this document to which group
        forShopUid: "", // required for platform user, assign this document to wihic shop
        publicAccess: true, // required for platform user, this document is public for all shops
      };
      // console.log("addFetch : " + JSON.stringify(body));
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async updateFetch(payload) {
      const body = {
        uid: payload.uid,
        name: payload.name,
        mimeType: "",
        data: payload.data,
        forGroupUid: "",
        forShopUid: "",
        publicAccess: true,
        version: payload.version,
      };
      // console.log("updateFetch : " + JSON.stringify(body));
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/update";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async deleteFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/doc-svc/document/delete/" + payload.uid;
          const response = http.delete(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async genBreakingXlsxFetch(payload) {
      const body = {
        shopUid: payload.shopUid,
        lotUid: payload.lotUid,
        shopInfo: payload.shopInfo,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/docgen-svc/breaking/xlsx";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
